module.exports = function getResource(label) {
    const resources = {
        usName: 'États-Unis',
        caName: 'Canada',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        address2Label: 'Appartement, étage, etc.',
        add: 'Ajouter',
        country: 'Pays',
        streetAddress: 'Adresse',
        city: 'Ville',
        phone: 'Téléphone',
        postalCode: 'Code postal',
        zipPostalCode: 'Code postal américain',
        emailAddress: 'Courriel',
        enterZipCodeText: 'Saisissez un code postal pour voir la ville et l’État ou la région.',
        region: 'Région',
        stateRegion: 'État/Région',
        province: 'Province',
        emailRequiredText: 'Vous devez fournir votre adresse courriel pour recevoir les notifications d’expédition et suivre votre commande.'
    };

    return resources[label];
};
